import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll } from 'services/WService.js';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [zone, setBonoZone] = useState([]);
  const [GroupC, setGroupCommission] = useState([]);
  const [TypeW, serTypeWorker] = useState([]);

  const [openModalBPartner, setOpenModalBPartner] = useState(false); //Abrir modal
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listBonoZone() {
    let response = await wsGetAll('base/zone');
    if (response.success) setBonoZone(response.data);
  }


  async function listGroupCommissions() {
    let response = await wsGetAll('sale/grupo-comisiones');
    if (response.success) setGroupCommission(response.data);
  }

  async function listTypeWorker() {
    let response = await wsGetAll('sale/tipo-trabajadores');
    if (response.success) serTypeWorker(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        base_zone_id: null,
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            base_zone_id : item.ZONA,
            base_grupo_comisione_id: item.GRUPOCOMISION,
            base_tipo_trabajador_id: item.TIPOTRABAJADOR,
            peso: item.PESO,
            importe_comision: item.IMPORTECOMISION,
          };
        }),
        // SlpName: dataImport.nameFile,
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.base_zone_id) {
      setDataChanging((prev) => ({
        ...prev,
        base_zone_id: bPartnerSelect?.base_zone_id || null,
      }));
    }
  }, [bPartnerSelect]);

  
  useEffect(() => {
      if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) listBonoZone(); listGroupCommissions(); listTypeWorker();
      setDataChanging(customerPortfolioB);
      }
  }, [customerPortfolioB.open]);

  return (
    <>
      <Modal
        title={`Nuevo bono para una zona`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.base_zone_id
            ? 'sale/bono-zone'
            : 'sale/bono-zone/multiple'
        }
        dataForce={
          dataChanging.base_zone_id
            ? {
              base_zone_id: dataChanging.base_zone_id,
              base_grupo_comisione_id: dataChanging.base_grupo_comisione_id,
              base_tipo_trabajador_id: dataChanging.base_tipo_trabajador_id,
              peso: dataChanging.peso,
              importe_comision: dataChanging.importe_comision,
            }
            : {
                base_zone_id: cuota.valueSearch?.base_zone_id,
                customers: bPartnerSelect?.customers,
                force: 'N'
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
              disableClearable
              options={zone}
              getOptionLabel={(item) => `${item.description}`}
              renderInput={(params) => (
                  <TextField {...params} label="Zonas" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('base_zone_id', item?.id); setDataImport(null);}}
              value={zone.find((zones) => zones.id === dataChanging.base_zone_id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate="ZONA"
            sortDuplicate="ZONA"
            downTemplate={{
                fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de bonos zonas`,
                fields: ['ZONA','GRUPOCOMISION','TIPOTRABAJADOR','PESO','IMPORTECOMISION']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {/* {dataChanging.base_zone_id ? (
          <>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Tipo</InputLabel>
              <Select
                required
                value={dataChanging.type || ''}
                inputProps={{
                  name: 'type',
                  onChange: (e) => handleChange('type', e.target.value),  
                }}
              >
                <MenuItem value="SU">Supervisor</MenuItem>
                <MenuItem value="VE">Vendedor</MenuItem>
              </Select>
            </FormControl>
          </>
        ) : undefined} */}
        {dataChanging.base_zone_id ? (
          <>
            <Autocomplete
              disableClearable
              options={GroupC}
              getOptionLabel={(item) => `${item.description}`}
              renderInput={(params) => (
                  <TextField {...params} label="Grupo por comisiones" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('base_grupo_comisione_id', item?.id); setDataImport(null);}}
              value={GroupC.find((group) => group.id === dataChanging.base_grupo_comisione_id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <Autocomplete
              disableClearable
              options={TypeW}
              getOptionLabel={(item) => `${item.description}`}
              renderInput={(params) => (
                  <TextField {...params} label="Tipo de trabajador" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('base_tipo_trabajador_id', item?.id); setDataImport(null);}}
              value={TypeW.find((type) => type.id === dataChanging.base_tipo_trabajador_id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <TextField
              label="Peso"
              fullWidth
              type="number"
              name="peso"
              margin="normal"
              value={dataChanging.peso || ''}
              onChange={(e) => handleChange('peso', e.target.value)}
              required
            />
            <TextField
              label="Importe de comision"
              fullWidth
              type="number"
              name="importe_comision"
              margin="normal"
              value={dataChanging.importe_comision || ''}
              onChange={(e) => handleChange('importe_comision', e.target.value)}
              required
            />
          </>
        ): undefined}
      </Modal>
    </>
  );
});
